import React from 'react'
import Link from "./Link"
import Label from "./Label"
import { pushRoute } from "../route"
import Arrow from "../../completion/images/Arrow"
import { colors, fontWeight } from "buoy-theme"

const LinkBack = Link.extend`
  text-decoration: none;
  display: flex;
  width: auto;
  margin-left: 22px;
  &:hover {
    text-decoration: none;
    color: ${colors.primary};
  }
`

const BackLabel = Label.extend`
  font-weight: ${fontWeight.medium};
  margin: 0;
  font-size: 10px;
  display: inline-block;
  vertical-align: middle;
`

const ArrowStyle = {
  display: 'inline-block',
  verticalAlign: 'middle',
  position: 'relative'
}

const BackLink = ({ link, maintainState }) => (
  <LinkBack onClick={() => pushRoute(link, maintainState)}>
    <Arrow small color="primary" rotation="90deg" style={ArrowStyle} />
    <BackLabel color="primary">BACK</BackLabel>
  </LinkBack>
)


export { BackLink as default }



// WEBPACK FOOTER //
// ./assets/common/components/BackLink.js